import React from "react"

const ImageLegend = ({ children, className = "", ...rest }) => (
  <div
    {...rest}
    className={`mb-4 font-sans text-sm text-gray-500 text-center mt-1 italic ${className}`}
  >
    {children}
  </div>
)

export default ImageLegend
